/**
 * DebtProjectTabs - Tab Switcher Component
 * Manages tab interface for switching between multiple existing debt projects.
 * Part of Frontend Workflow - SPJ-140
 */

import { Button, ButtonGroup, HStack } from '@chakra-ui/react';
import type React from 'react';

import type { ExistingDebtInputForm } from '~/types';

interface DebtProjectTabsProps {
  projects: ExistingDebtInputForm[];
  activeTab: number;
  onTabChange: (index: number) => void;
}

export const DebtProjectTabs: React.FC<DebtProjectTabsProps> = ({
  projects,
  activeTab,
  onTabChange,
}) => {
  const getTabLabel = (project: ExistingDebtInputForm, index: number) => {
    // Use name if available, fallback to id, fallback to index
    if (project.name?.trim()) {
      return project.name;
    }
    if (project.id?.trim()) {
      return project.id;
    }
    return `Debt Project ${index + 1}`;
  };

  return (
    <HStack gap={3} overflowX="auto" flexWrap="nowrap">
      <ButtonGroup size="sm" variant="outline">
        {projects.map((project, index) => (
          <Button
            key={project.id || `debt-project-${index}`}
            onClick={() => onTabChange(index)}
            variant={activeTab === index ? 'solid' : 'outline'}
          >
            {getTabLabel(project, index)}
          </Button>
        ))}
      </ButtonGroup>
    </HStack>
  );
};
